import React from 'react';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '../../../js/AppState';
import classes from './Footer.module.css';

import Texts from 'react-sdk/Texts';

import Gouvernement from './Republique-francaise-logo.png'
import banque_territoires from './banque-des-territoires-vector.png'
import ccca_btp from './CCCA-BTP.png'
import cma_paca from './CMA_Provence_Alpe_Cote_Azur.png'
import france_2030 from './Logo_France_2030.png'
import succubus_footer_logo from './succubus-footer-logo.png'


const Footer = () => {
  function handleMentionsClick(e) {
    e.preventDefault()
    PopupsManager.open(POPUPS.MENTIONS_LEGALES)
  }
  let mentions_link = Texts.get("footer-mentions-legales-link", {fallback: null})

  return (
    <div className={classes.Footer}>
      <div>
        {mentions_link &&
        <a className={classes.mentions_legales_btn} href="#" onClick={handleMentionsClick}>{Texts.get("footer-mentions-legales-link")}</a>}
      </div>
      <div className={classes.logos_partenaires}>
        <div className={classes.logos_partenaires_phrase} dangerouslySetInnerHTML={{__html: Texts.get("footer-partenaires-phrase")}} />
        {/* <div className={classes.logos_partenaires_images}> */}
          <img src={Gouvernement} alt="Logo gouvernement français" />
          <a target="_blank" href="https://www.economie.gouv.fr/france-2030"><img src={france_2030} alt="Logo France 2023" /></a>
          <a target="_blank" href="https://www.caissedesdepots.fr/"><img src={banque_territoires} alt="Logo Banque des Territoires" /></a>
          <a target="_blank" href="https://www.ccca-btp.fr/"><img src={ccca_btp} alt="Logo CCCABTP" /></a>
          <a target="_blank" href="https://www.cmar-paca.fr/"><img src={cma_paca} alt="Logo CMA PACA" /></a>
        {/* </div> */}

      </div>
      {/*<div className={classes.succubus_baseline}>
        <img src={succubus_footer_logo} alt="logo-succcubus" />
        <span dangerouslySetInnerHTML={{__html: Texts.get("succubus-tagline")}} />
      </div>*/}
    </div>
  );
};

export default Footer;
